import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import useAuth from '../utils/useAuth';

import logoBlanco from '../assets/logos/logo-enstock-blanco.svg';
import smartCotiLogo from '../assets/logos/smart_coti-logo.svg';
import natureIcon from '../assets/icons/nature.svg';

import '../styles/components/HeaderV2.scss';

const NAV_LINKS = [
  { label: 'Inicio',     to: '/' },
  { label: 'Categorías', to: '/categorias' },
  { label: 'Productos',  to: '/productos/todos' },
];

const HeaderV2 = () => {
  const { toggleCart, cartItems, openSmartCoti } = useCart();
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setMenuOpen(false); }, [location.pathname]);

  const cartCount = cartItems.length;

  return (
    <header className={`HdrV2 ${scrolled ? 'HdrV2--scrolled' : ''}`}>
      <div className="HdrV2__inner container">

        <Link to="/" className="HdrV2__logo">
          <img src={logoBlanco} alt="En Stock Promocionales" />
        </Link>

        <nav className="HdrV2__nav">
          {NAV_LINKS.map(({ label, to }) => (
            <Link
              key={to}
              to={to}
              className={`HdrV2__nav-link ${location.pathname === to ? 'active' : ''}`}
            >
              {label}
            </Link>
          ))}
        </nav>

        <div className="HdrV2__actions">
          <button className="HdrV2__smart-btn" onClick={openSmartCoti} title="Cotización inteligente">
            <img src={smartCotiLogo} alt="Smart Coti" />
          </button>

          <button className="HdrV2__cart-btn" onClick={toggleCart} aria-label="Carrito">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>
              <line x1="3" y1="6" x2="21" y2="6"/>
              <path d="M16 10a4 4 0 0 1-8 0"/>
            </svg>
            {cartCount > 0 && <span className="HdrV2__cart-badge">{cartCount}</span>}
          </button>

          {isAuthenticated && (
            <Link to="/admin/sync" className="HdrV2__admin-btn">Admin</Link>
          )}

          <Link to="/categorias" className="HdrV2__cta">Ver catálogo</Link>

          <button
            className={`HdrV2__hamburger ${menuOpen ? 'open' : ''}`}
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="Menú"
          >
            <span /><span /><span />
          </button>
        </div>
      </div>

      <div className={`HdrV2__mobile ${menuOpen ? 'open' : ''}`}>
        {NAV_LINKS.map(({ label, to }) => (
          <Link key={to} to={to} className="HdrV2__mobile-link">{label}</Link>
        ))}
        <button className="HdrV2__mobile-coti" onClick={() => { openSmartCoti(); setMenuOpen(false); }}>
          Cotización inteligente
        </button>
      </div>

      <div className="HdrV2__quicknav">
        <div className="HdrV2__quicknav-inner container">
          <a href="/#deals" className="HdrV2__qbtn">Ofertas</a>
          <Link to="/productos/todos"           className="HdrV2__qbtn">Todos los productos</Link>
          <Link to="/categorias/ecologia-ecopromo" className="HdrV2__qbtn HdrV2__qbtn--eco">
            <img src={natureIcon} alt="" className="HdrV2__qbtn-icon" />
            Ecología
          </Link>
          <Link to="/categorias" className="HdrV2__qbtn">Categorías y productos</Link>
        </div>
      </div>
    </header>
  );
};

export default HeaderV2;
